import { create } from "zustand";

/**
 * 근거 창이 가리키는 후보 — 어느 셀의 몇 번째 후보인가. 선택이 다른 셀로 옮겨가면 cellId 가
 * 어긋나 자동으로 닫힌 것과 같다.
 *
 * 문서 조립 컴포넌트의 useState 가 아니라 store 인 이유: 이 값을 쓰는 곳은 근거 창과 패널 카드뿐인데,
 * 최상위 state 로 두면 ←/→ 한 번에 본문·목차·헤더까지 다시 렌더된다.
 */
type EvidenceTarget = { cellId: string; index: number } | null;

export const useDsdReviewEvidenceStore = create<{
  target: EvidenceTarget;
  setTarget: (target: EvidenceTarget) => void;
}>((set) => ({
  target: null,
  setTarget: (target) => set({ target }),
}));

/** 그 셀에 대해 근거 창이 열려 있으면 후보 index, 아니면 null */
export const useDsdReviewEvidenceIndex = (cellId: string | null) =>
  useDsdReviewEvidenceStore((state) =>
    state.target && state.target.cellId === cellId ? state.target.index : null,
  );
